import React, {
  useState,
  useEffect,
  useCallback,
  useRef,
  SetStateAction,
  Dispatch,
} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Form } from '@unform/web';
import { toast } from 'react-toastify';
import * as Yup from 'yup';
import { Img } from 'react-image';
import { FormHandles } from '@unform/core';
import PerfectScrollbar from 'react-perfect-scrollbar';

import api from 'services/api';
import { show } from 'store/modules/dialog/actions';
import getValidationErrors from 'services/getValidationErros';
import notfound from 'assets/semimagem.png';
import AppError from 'utils/AppError';

import Card from 'components/Card';
import PlayerBaixa from 'components/PlayerBaixa';
import Button from 'components/Button';
import Input from 'components/Input';
import Radio from 'components/Radio';
import Spinner from 'components/Spinner';
import ReactDropzoneInput from 'components/DropZone';

import {
  Content,
  ProgramaEdit,
  ButtonGroup,
  BaseEdit,
  BaseView,
  Logo,
} from './styles';

import { Emissora, Programa as ProgramaItem } from 'pages/@types';
import { ThumbnailContainer } from 'styles/global';
import { FiPlay } from 'react-icons/fi';
import { format } from 'date-fns';
import { Permissao, Role } from 'utils/variables';
import { usePermit } from 'utils/hooks/usePermit';

// configuração do validator
const schema = Yup.object().shape({
  mnemonico: Yup.string()
    .required('Campo Obrigatório')
    .max(35, 'O Mnemonico excedeu o limite de 35 caracteres')
    .uppercase(),
  nome: Yup.string()
    .required('Campo Obrigatório')
    .max(35, 'O Nome excedeu o limite de 35 caracteres')
    .uppercase(),
  sigla: Yup.string()
    // .required('Campo Obrigatório')
    .matches(/^[a-zA-Z0-9- ./]*$/, 'Sigla contém caracteres especiais')
    .max(4, 'A Sigla pode conter até 4 caracteres')
    // .length(4, 'A Sigla precisa conter 4 caracteres')
    .uppercase(),
  genero: Yup.string()
    .nullable()
    .required('Campo Obrigatório'),
  exibicaolocal: Yup.string()
    .nullable()
    .required('Campo Obrigatório'),
});
const schemaBase = Yup.object().shape({
  duracao: Yup.number().typeError(
    'A duração é obrigatória e deve ser um número',
  ),
  file: Yup.array()
    .nullable()
    .required('Arquivo de Base Obrigatório'),
});
interface EmissoraOption {
  id: number | string;
  label: string;
}
interface BasePrograma {
  id: number;
  thumbnail_url: string | null;
  preview_url: string | null;
  emissora: Emissora;
  duracao: number;
  created_at: string;
}
interface Props {
  selected: ProgramaItem;
  setProgramas: Dispatch<SetStateAction<ProgramaItem[]>>;
  setEditMode: Dispatch<SetStateAction<boolean>>;
  setSelected: Dispatch<React.SetStateAction<ProgramaItem>>;
}
export default function ProgramaStore(props: Props) {
  const [loadingSubmit, setLoadingSubmit] = useState(false);
  const [loadingBase, setLoadingBase] = useState(false);
  const [loadingOptions, setLoadingOptions] = useState(false);
  const [emissoras, setEmissoras] = useState([] as EmissoraOption[]);
  const [basesProgramas, setBasesProgramas] = useState<BasePrograma[]>([]);
  const [player, setPlayer] = useState({
    open: false,
    midia_url: '',
    pipe: false,
  });
  const [view, setView] = useState('programa');
  const dispatch = useDispatch();

  /*
   * REF
   */
  const formRef = useRef<FormHandles>(null);
  const formRefBase = useRef<FormHandles>(null);
  const inputFileRef = useRef<HTMLInputElement>(null);

  const hasProgramaEditor = usePermit([], [Permissao.PROGRAMAEDITOR]);
  const hasBasePrograma = usePermit([Role.PROMO], []);

  /**
   * PLAYER
   */
  function handlePlayer(previewurl: string | null) {
    if (previewurl) {
      setPlayer({
        open: !player.open,
        midia_url: previewurl,
        pipe: false,
      });
    } else {
      dispatch(
        show({
          type: 'warning',
          text: 'Preview indisponível no momento',
          showConfirmButton: false,
        }),
      );
    }
  }

  // fecha player
  function closeVideo() {
    setPlayer({
      open: !player.open,
      midia_url: '',
      pipe: false,
    });
  }
  const handleSuccessMessage = useCallback(
    data => {
      const option = {
        type: 'success',
        confirmButtonText: '',
        timer: 3000,
        cancelButtonText: 'NÃO',
        showCancelButton: false,
        showConfirmButton: false,
        showCloseButton: true,
        ...data,
      };

      dispatch(show(option));
    },
    [dispatch],
  );

  const handleLogoUpload = useCallback(
    async e => {
      const file = e.target.files[0];
      if (file) {
        // toast.success('Iniciando upload da logo');
        setLoadingSubmit(true);
        const data = new FormData();
        data.append('file', file);
        try {
          const response = await api.put(
            `/logoprogramasfile/${props.selected.id}`,
            data,
            { timeout: 180000 * 3 },
          );

          if (response?.data) {
            const logo_url = response.data.logo_url;
            props.setSelected(prevState => ({
              ...prevState,
              logo_url: logo_url,
            }));
            props.setProgramas(prevState =>
              prevState.map(p =>
                p.id === props.selected.id ? { ...p, logo_url: logo_url } : p,
              ),
            );
            toast.success('Logo carregada com sucesso');
          } else toast.error('Falha ao fazer upload da logo');

          if (inputFileRef.current) inputFileRef.current.value = '';
        } catch (e) {
          if (e instanceof Error) toast.error(e.message);
          else if (e instanceof AppError) toast.error(e.message);
          else {
            const appError = e as AppError;
            if (appError.message) toast.error(appError.message);
            else toast.error('Erro inesperado');
          }
        }
        setLoadingSubmit(false);
      }
    },
    [props],
  );

  const handleSubmitBase = useCallback(
    async data => {
      try {
        if (formRefBase.current) {
          formRefBase.current.setErrors({});

          await schemaBase.validate(data, { abortEarly: false });

          if (data.file[0].name.toUpperCase().includes('.MXF')) {
            setLoadingSubmit(true);
            const responseCreate = await api.post('/baseprogramas', {
              programa_id: props.selected.id,
              ...(data.emissora && { emissora_id: Number(data.emissora) }),
              duracao: data.duracao,
            });
            if (responseCreate && responseCreate.data) {
              const formData = new FormData();
              formData.append('file', data.file[0]);
              await api.put(
                `/baseprogramasfile/${responseCreate.data.id}`,
                formData,
              );
            }
            toast.success('Base carregada com sucesso');
            props.setEditMode(false);
          } else formRefBase.current.setErrors({ file: 'Formato inválido' });
        }
      } catch (err) {
        if (err instanceof Yup.ValidationError) {
          const errors = getValidationErrors(err);
          if (formRefBase.current) formRefBase.current.setErrors(errors);
          toast.error(err.message);
        } else if (err instanceof Error) {
          toast.error(err.message);
        } else {
          const appError = err as AppError;
          toast.error(appError.message);
        }
      } finally {
        setLoadingSubmit(false);
      }
    },
    [props],
  );

  const handleSubmit = useCallback(
    async _data => {
      setLoadingSubmit(true);
      try {
        const data = await schema.validate({ ..._data }, { abortEarly: false });
        if (formRef.current) formRef.current.setErrors({});
        if (data) {
          if (Object.keys(props.selected).length === 0) {
            const response = await api.post<ProgramaItem>('/programas', {
              ...data,
              exibicaolocal: data.exibicaolocal === 'SIM',
            });
            handleSuccessMessage({
              contentHTML: `<h3>Programa ${data.mnemonico} criado!</h3>`,
            });
            props.setProgramas(prevState => [...prevState, response.data]);
          } else {
            const response = await api.put<ProgramaItem>(
              `/programas/${props.selected.id}`,
              {
                ...data,
                exibicaolocal: data.exibicaolocal === 'SIM',
              },
            );
            handleSuccessMessage({
              contentHTML: `<h3>Programa ${data.mnemonico} atualizado!</h3>`,
            });
            props.setProgramas(prevState =>
              prevState.map(p =>
                p.id === props.selected.id ? response.data : p,
              ),
            );
          }
          props.setEditMode(false);
        }
      } catch (err) {
        if (err instanceof Yup.ValidationError) {
          const errors = getValidationErrors(err);
          if (formRef.current) formRef.current.setErrors(errors);
          toast.error(err.message);
        } else if (err instanceof Error) {
          toast.error(err.message);
        } else {
          const appError = err as AppError;
          toast.error(appError.message);
        }
      }
      setLoadingSubmit(false);
    },
    [handleSuccessMessage, props],
  );

  useEffect(() => {
    async function loadBases() {
      setLoadingBase(true);
      try {
        const response = await api.get('/baseprogramas', {
          params: { programa_id: props.selected.id },
        });
        if (response && response.data) setBasesProgramas(response.data);
        else setBasesProgramas([]);
      } catch (e) {
        if (e instanceof Error) toast.error(e.message);
        else toast.error('Erro inesperado');
      } finally {
        setLoadingBase(false);
      }
    }
    if (Object.keys(props.selected).length !== 0 && hasBasePrograma)
      loadBases();
  }, [hasBasePrograma, props.selected]);

  useEffect(() => {
    if (formRef.current) {
      if (Object.keys(props.selected).length !== 0) {
        const p = props.selected;
        formRef.current.setFieldValue('mnemonico', p.mnemonico);
        formRef.current.setFieldValue('nome', p.nome);
        formRef.current.setFieldValue('sigla', p.sigla);
        formRef.current.setFieldValue('locucaobase', p.locucaobase);
        formRef.current.setFieldValue('genero', p.genero);
        formRef.current.setFieldValue(
          'exibicaolocal',
          p.exibicaolocal ? 'SIM' : 'NÃO',
        );
      } else formRef.current.reset();
    }
    setView('programa');
  }, [props.selected]);

  /**
   * USE EFFECT
   */
  useEffect(() => {
    const controller = new AbortController();
    async function buscaEmissoras() {
      setLoadingOptions(true);
      try {
        const { data } = await api.get(`/emissoras`, {
          signal: controller.signal,
        });

        if (data) {
          setEmissoras(
            data.map((emi: Emissora) => ({
              id: emi.id,
              label: emi.nome,
              // siglapromo: emi.siglapromo,
            })),
          );
        } else toast.error('Falha de comunicação com o sistema');
      } catch (e) {
        if (e instanceof Error) toast.error(e.message);
        else toast.error('Erro inesperado');
      } finally {
        setLoadingOptions(false);
      }
    }
    buscaEmissoras();
    return () => {
      controller.abort();
    };
  }, []);

  return (
    <Card>
      {view === 'programa' && (
        <Content>
          <PerfectScrollbar>
            <Form
              initialData={props.selected}
              ref={formRef}
              onSubmit={handleSubmit}
              autoComplete="off"
            >
              <ProgramaEdit>
                <div>
                  {props.selected.mnemonico && (
                    <h4>
                      {props.selected.mnemonico} (
                      {props.selected.sigla
                        ? props.selected.sigla + ' - ' + props.selected.nome
                        : props.selected.nome}
                      )
                    </h4>
                  )}
                  <section>
                    <h5>Mnemonico: </h5>
                  </section>
                  <div>
                    <Input
                      name="mnemonico"
                      placeholder="Mnemonico (Nome Promo) *"
                      disabled={loadingSubmit || !hasProgramaEditor}
                    />
                    <section>
                      <h5>Nome: </h5>
                    </section>
                    <Input
                      name="nome"
                      placeholder="Nome (Nome OPEC) *"
                      disabled={loadingSubmit || !hasProgramaEditor}
                    />
                    <section>
                      <h5>Sigla: </h5>
                    </section>
                    <Input
                      name="sigla"
                      placeholder="Sigla (Sigla OPEC) *"
                      disabled={loadingSubmit || !hasProgramaEditor}
                    />
                    <section>
                      <h5>Locução Base: </h5>
                    </section>
                    <Input
                      name="locucaobase"
                      placeholder="Locução base do programa *"
                      disabled={loadingSubmit || !hasProgramaEditor}
                    />
                    <section>
                      <h5>Gênero: </h5>
                    </section>
                    <Radio
                      name="genero"
                      options={[
                        { id: 'RPC', label: 'RPC' },
                        { id: 'Globo', label: 'GLOBO' },
                      ]}
                      disabled={loadingSubmit || !hasProgramaEditor}
                    />
                    <section>
                      <h5>Exibição Local: </h5>
                    </section>
                    <Radio
                      name="exibicaolocal"
                      options={[
                        { id: 'SIM', label: 'SIM' },
                        { id: 'NÃO', label: 'NÃO' },
                      ]}
                      disabled={loadingSubmit || !hasProgramaEditor}
                    />
                    {props.selected.logo_url && (
                      <div>
                        <section>
                          <h5>Logo:</h5>
                        </section>
                        <Logo
                          src={props.selected.logo_url}
                          alt={`Logo de ${props.selected.mnemonico}`}
                        />
                      </div>
                    )}
                  </div>
                </div>
                <ButtonGroup>
                  <Button
                    onClick={() => props.setEditMode(false)}
                    color="primary"
                  >
                    FECHAR
                  </Button>
                  <div>
                    <input
                      type="file"
                      ref={inputFileRef}
                      style={{ display: 'none' }}
                      onChange={e => handleLogoUpload(e)}
                    />
                    <Button
                      type="button"
                      onClick={e => {
                        if (inputFileRef && inputFileRef.current)
                          inputFileRef.current.click();
                      }}
                      color="primary"
                      disabled={loadingSubmit || !hasBasePrograma}
                    >
                      {!loadingSubmit ? (
                        props.selected.logo_url ? (
                          'ALTERAR LOGO'
                        ) : (
                          'CARREGAR LOGO'
                        )
                      ) : (
                        <Spinner type="ThreeDots" />
                      )}
                    </Button>
                    {!loadingBase &&
                      (basesProgramas.length > 0 ? (
                        <Button
                          type="button"
                          onClick={e => {
                            setView('base');
                          }}
                          color="primary"
                          disabled={loadingSubmit || !hasBasePrograma}
                        >
                          {!loadingSubmit ? (
                            'BASES'
                          ) : (
                            <Spinner type="ThreeDots" />
                          )}
                        </Button>
                      ) : (
                        <Button
                          onClick={() => setView('editbase')}
                          color="primary"
                          disabled={loadingSubmit || !hasBasePrograma}
                        >
                          CARREGAR BASE
                        </Button>
                      ))}
                    <Button
                      type="submit"
                      disabled={loadingSubmit || !hasProgramaEditor}
                      color="primary"
                    >
                      {!loadingSubmit ? (
                        Object.keys(props.selected).length !== 0 ? (
                          'ATUALIZAR'
                        ) : (
                          'SALVAR'
                        )
                      ) : (
                        <Spinner type="ThreeDots" />
                      )}
                    </Button>
                  </div>
                </ButtonGroup>
              </ProgramaEdit>
            </Form>
          </PerfectScrollbar>
        </Content>
      )}
      {view === 'base' && (
        <PerfectScrollbar>
          <BaseView>
            <div>
              <h4>
                {props.selected.mnemonico} (
                {props.selected.sigla
                  ? props.selected.sigla + ' - ' + props.selected.nome
                  : props.selected.nome}
                )
              </h4>
              <div>
                {basesProgramas.map(base => {
                  return (
                    <div>
                      <ThumbnailContainer>
                        <Img
                          onClick={() => handlePlayer(base.preview_url)}
                          src={base.thumbnail_url || notfound}
                          loader={<Spinner />}
                          unloader={<img src={notfound} alt="sem thumb" />}
                        />
                        <FiPlay className="icon_play" />
                      </ThumbnailContainer>
                      <h4>
                        {base.duracao}s - {base.emissora?.nome || 'REDE'}
                      </h4>
                      <p>
                        Carregada em:{' '}
                        {format(new Date(base.created_at), 'dd/MM/yyyy HH:mm')}
                      </p>
                    </div>
                  );
                })}
              </div>
            </div>
            <ButtonGroup>
              <Button onClick={() => props.setEditMode(false)} color="primary">
                FECHAR
              </Button>
              <Button
                onClick={() => setView('editbase')}
                color="primary"
                disabled={loadingSubmit || !hasBasePrograma}
              >
                CARREGAR BASE
              </Button>
            </ButtonGroup>
          </BaseView>
        </PerfectScrollbar>
      )}
      {view === 'editbase' && (
        <Form ref={formRefBase} onSubmit={handleSubmitBase}>
          <BaseEdit>
            <div>
              <h4>
                {props.selected.mnemonico} (
                {props.selected.sigla
                  ? props.selected.sigla + ' - ' + props.selected.nome
                  : props.selected.nome}
                )
              </h4>
              <section>
                <h5>Duração: </h5>
              </section>
              <Input
                name="duracao"
                disabled={loadingSubmit || loadingOptions}
              />
              <section>
                <h5>Emissoras: </h5>
              </section>
              <Radio
                name="emissora"
                columns="1fr 1fr 1fr"
                options={emissoras}
                disabled={loadingSubmit || loadingOptions}
              />
              <ReactDropzoneInput name="file" type="mxf" />
            </div>
            <ButtonGroup>
              <Button onClick={() => props.setEditMode(false)} color="primary">
                {!loadingSubmit ? 'FECHAR' : <Spinner type="ThreeDots" />}
              </Button>
              <Button
                type="submit"
                disabled={loadingSubmit || !hasBasePrograma}
                color="primary"
              >
                {!loadingSubmit ? 'SALVAR' : <Spinner type="ThreeDots" />}
              </Button>
            </ButtonGroup>
          </BaseEdit>
        </Form>
      )}
      <PlayerBaixa
        open={player.open}
        toggleModal={() => closeVideo()}
        pipe={player.pipe}
        url={player.midia_url}
      />
    </Card>
  );
}
